import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { newsArticles } from '../data/sbbData';
import { ChevronRight, Search, Calendar, User } from 'lucide-react';
import PageHero from '../components/PageHero';

export default function NewsArticlesListing() {
  const { lang, t } = useLanguage();
  const [selectedType, setSelectedType] = useState('all');
  const [searchQuery, setSearchQuery] = useState('');

  const filteredArticles = newsArticles.filter((art) => {
    const matchesType = selectedType === 'all' || art.type === selectedType;
    const matchesQuery = art.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         art.excerpt.toLowerCase().includes(searchQuery.toLowerCase());
    return matchesType && matchesQuery;
  });

  return (
    <div className="news-articles-page">
      {/* Page Hero */}
      <PageHero eyebrow="Pusat Informasi & Media" title={t('nav_news')} subtitle="Kumpulan siaran pers resmi, berita korporat, dan artikel edukasi teknologi beton Solusi Bangun Beton." image="/reference-images/news-1.webp" />

      {/* Breadcrumbs */}
      <div className="breadcrumb-wrapper">
        <div className="container">
          <ul className="breadcrumb-list">
            <li><Link to="/">{t('nav_home')}</Link></li>
            <li><span className="separator">/</span></li>
            <li><span className="current">{t('nav_news')}</span></li>
          </ul>
        </div>
      </div>

      {/* Main Content */}
      <section className="section">
        <div className="container">
          {/* Controls Bar */}
          <div className="filter-bar-wrapper">
            <div className="filter-chips">
              <button 
                className={`chip-btn ${selectedType === 'all' ? 'active' : ''}`}
                onClick={() => setSelectedType('all')}
              >
                Semua Publikasi
              </button>
              <button 
                className={`chip-btn ${selectedType === 'Siaran Pers' ? 'active' : ''}`}
                onClick={() => setSelectedType('Siaran Pers')}
              >
                {t('press_release')}
              </button>
              <button 
                className={`chip-btn ${selectedType === 'Artikel' ? 'active' : ''}`}
                onClick={() => setSelectedType('Artikel')}
              >
                {t('articles')} & Edukasi
              </button>
            </div>

            <div className="search-input-box">
              <Search size={18} className="search-icon" />
              <input 
                type="text" 
                placeholder="Cari judul berita atau artikel..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </div>
          </div>

          {/* Grid View */}
          {filteredArticles.length > 0 ? (
            <div className="grid-3">
              {filteredArticles.map((art) => (
                <div key={art.slug} className="sbb-card">
                  <img src={art.image} alt={art.title} className="sbb-card-img" />
                  <div className="sbb-card-body">
                    <div className="post-meta-row">
                      <span className="sbb-card-tag">{art.type}</span>
                      <span className="post-date-tag">{art.date}</span>
                    </div>

                    <h3 className="sbb-card-title">{art.title}</h3>
                    <p className="sbb-card-desc">{art.excerpt}</p>

                    <Link to={`/blog/${art.slug}`} className="btn btn-secondary btn-sm" style={{ marginTop: 'auto' }}>
                      <span>{t('read_more')}</span>
                      <ChevronRight size={14} />
                    </Link>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="empty-state-box text-center">
              <p className="no-data-text">{t('no_results')}</p>
            </div>
          )}
        </div>
      </section>

      <style>{`
        .post-meta-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 8px;
        }

        .post-date-tag {
          font-size: 12px;
          color: var(--color-text-muted);
        }
      `}</style>
    </div>
  );
}
